var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDjango(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5441 0H34.5374V41.6281C29.9239 42.5047 26.5366 42.8549 22.8581 42.8549C11.8791 42.8545 6.15613 37.8916 6.15613 28.3723C6.15613 19.2036 12.2298 13.2473 21.6313 13.2473C23.0914 13.2473 24.2009 13.3641 25.5441 13.7143V0ZM25.5441 20.9537C24.493 20.6035 23.6169 20.4871 22.5075 20.4871C17.9528 20.4871 15.3244 23.2899 15.3244 28.1952C15.3244 32.9841 17.8359 35.6116 22.4494 35.6116C23.4416 35.6116 24.2593 35.5532 25.5441 35.3787V20.9537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8434 13.8881V34.7361C48.8434 41.9192 48.3175 45.3644 46.741 48.3426C45.2809 51.2047 43.3538 53.0146 39.383 55.0002L31.032 51.0294C35.0032 49.1603 36.9299 47.5262 38.1563 45.0138C39.441 42.4447 39.8505 39.4665 39.8505 31.6411V13.8881H48.8434ZM39.8501 0.0478516H48.8434V9.27496H39.8501V0.0478516Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.8c3be6f8274fcc761a086fe913988e6d.svg";
export { ForwardRef as ReactComponent };